var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.873 0L26.1465 0.0136719C27.4944 0.150703 28.5466 1.28985 28.5469 2.67383V22.0068C28.5469 23.4833 27.3495 24.6816 25.873 24.6816H2.67383C1.19737 24.6816 0 23.4833 0 22.0068V2.67383C0.000239777 1.19754 1.19753 4.40834e-05 2.67383 0H25.873ZM1.47949 13.082V22.0068C1.47949 22.6657 2.01486 23.2011 2.67383 23.2012H6.28223V13.082H1.47949ZM7.76465 13.082V23.2012H25.873C26.5319 23.2011 27.0674 22.6657 27.0674 22.0068V13.082H7.76465ZM2.67383 1.47949C2.01498 1.47954 1.47973 2.0151 1.47949 2.67383V11.5996H6.28223V1.47949H2.67383ZM7.76465 1.47949V11.5996H27.0674V2.67383C27.0671 2.01508 26.5318 1.47954 25.873 1.47949H7.76465Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.b891ed176b57d6881f731ab2005d65b0.svg";
export { ForwardRef as ReactComponent };